import { observableGET } from "@/api/apiClient";

import { combineEpics, ofType } from "redux-observable";
import { catchError, mergeMap, of } from "rxjs";
import {
  userPropertiesCountFailure,
  userPropertiesCountRequest,
  userPropertiesCountSuccess,
  userPropertiesCountYearToDateRequest,
  userPropertiesCountYearToDateSuccess,
  userPropertiesCountYearToDateFailure,
  userTotalPropertiesWorthRequest,
  userTotalPropertiesWorthSuccess,
  userTotalPropertiesWorthFailure
} from "./dashboard";

const fetchUserPropertyCountEpic = (action$) =>
  action$.pipe(
    ofType(userPropertiesCountRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;
      return observableGET(
        `/property/dashboard/user-properties-count/${userId}`
      ).pipe(
        mergeMap((response) => of(userPropertiesCountSuccess(response.data))),
        catchError((error) => of(userPropertiesCountFailure(error)))
      );
    })
  );

const fetchUserPropertyCountYearToDateEpic = (action$) =>
  action$.pipe(
    ofType(userPropertiesCountYearToDateRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;
      return observableGET(
        `/property/dashboard/user-properties-count-year-to-date/${userId}`
      ).pipe(
        mergeMap((response) =>
          of(userPropertiesCountYearToDateSuccess(response.data))
        ),
        catchError((error) => of(userPropertiesCountYearToDateFailure(error)))
      );
    })
  );

const fetchUserTotalPropertyWorthEpic = (action$) =>
  action$.pipe(
    ofType(userTotalPropertiesWorthRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;
      return observableGET(
        `/property/dashboard/user-properties-total-value/${userId}`
      ).pipe(
        mergeMap((response) =>
          of(userTotalPropertiesWorthSuccess(response.data))
        ),
        catchError((error) => of(userTotalPropertiesWorthFailure(error)))
      );
    })
  );

const dashboardEpic = combineEpics(
  fetchUserPropertyCountEpic,
  fetchUserPropertyCountYearToDateEpic,
  fetchUserTotalPropertyWorthEpic
);

export default dashboardEpic;
